export default {
    // 查询操作类型
    queryOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/queryOperationType', params, response);
    },
    // 删除操作类型
    deleteOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/deleteOperationType', params, response);
    },
    // 添加操作类型
    addOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/saveOperationType', params, response);
    },
    // 更新操作类型
    updateOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/updateOperationType', params, response);
    },
    // 获取所有操作类型
    getAllOperationType(params, response) {
        window.vue.$apiAxios.get('/auth/operationType/getAllOperationType', params, response);
    },
    // 批量更新操作类型
    updateOperationTypeBatch(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/updateOperationTypeBatch', params, response);
    },
    // 批量删除操作类型
    deleteOperationTypeBatch(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/deleteOperationTypeBatch', params, response);
    },
    // 获取所有系统
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 查询操作类型重复
    checkOperationType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/checkOperationType', params, response);
    }
};
